import templateUrl from './create-modal.html'
import './create-modal.scss'

const AdditionalTasksCreateModalComponent = {
  bindings: {},
  templateUrl,
  require: {
    modalCtrl: '^^cdblModal'
  },
  controller: class AdditionalTasksCreateModal {
    constructor ($timeout, ProjectService, AdditionalTasksService, ExperimentService) {
      'ngInject'
      this._identify = 'AdditionalTasksCreateModalComponent'
      this.$timeout = $timeout
      this.ProjectService = ProjectService
      this.AdditionalTasksService = AdditionalTasksService
      this.ExperimentService = ExperimentService

      this.formData = {
        taskType: 'task',
        title: null,
        description: null,
        price: null,
        hourlyRate: null,
        timeEstimate: null,
        billingFrequency: 'monthly',
        scopeCategories: []
      }

      this.billingPreview = null

      this.isProcessing = false


      this.temporaryDisableRetainers = this.ExperimentService.isOff('retainer-task-creation')
      this.taskType = {
        config: {
          type: 'radio-button-outline',
          horizontal: true
        },
        options: [
          {
            title: 'Additional Task',
            value: 'task',
            disabled: false
          },
          {
            title: 'Retainer Task',
            value: 'task-retainer',
            disabled: this.temporaryDisableRetainers
          }
        ]
      }

      this.scopeCategories = [
        { value: 'updates', name: 'Updates' },
        { value: 'uptime-monitoring', name: 'Uptime Monitoring' },
        { value: 'backups', name: 'Backups' },
        { value: 'dedicated-development-hours', name: 'Dedicated Development Hours' },
        { value: 'design', name: 'Design' },
        { value: 'content-edits', name: 'Content Edits' },
        { value: 'bug-fixes', name: 'Bug Fixes' },
        { value: 'seo-content-production', name: 'SEO & Content Production' },
        { value: 'performance-optimization', name: 'Performance Optimization' },
        { value: 'analytics-reporting', name: 'Analytics & Reporting' },
        { value: 'support-training-meetings', name: 'Support, Training & Meetings' },
        { value: 'other', name: 'Other' }
      ]
    }

    $onInit () {

    }

    onPriceChange () {
      if (!this.ProjectService.project) {
        return
      }

      this.AdditionalTasksService.getBillingPreview(this.ProjectService.project.id, this.formData.price)
        .then(response => {
          console.log('[AdditionalTasksCreateModalComponent] > onPriceChange', response)
          this.billingPreview = response.prices
        })
    }

    createTask () {
      console.log('[AdditionalTasksCreateModalComponent] > postTask', this.formData)

      if (!this.ProjectService.project) {
        console.error('[AdditionalTasksCreateModalComponent] > no project assigned in ProjectService', this.formData)
        return
      }

      this.isProcessing = true
      if (this.formData.taskType === 'task-retainer') {
        const payload = {
          retainer: {
            title: this.formData.title,
            description: this.formData.description,
            price: this.formData.price,
            task_id: this.ProjectService.project.id, // TODO: remove this after BE confirmation
            numberOfHours: this.formData.timeEstimate,
            baseHourlyRate: this.formData.hourlyRate,
            billingFrequency: this.formData.billingFrequency,
            scopeCategories: this.formData.scopeCategories || []
          }
        }
        this.AdditionalTasksService.createRetainerTask(this.ProjectService.project.id, payload)
          .then(task => {
            // SegmentAnalytics.trackRetainerPosted(task, Auth.me(), parentTask, buttonClicked);
            // $rootScope.$broadcast('sub-task-created', task);
            this.ProjectService.addAdditionalTaskToProject(task, true)
            this.modalCtrl.close()
          })
          .finally(() => {
            this.isProcessing = false
          })
      } else {
        const payload = {
          title: this.formData.title,
          description: this.formData.description,
          price: this.formData.price,
          numberOfHours: this.formData.timeEstimate,
          baseHourlyRate: this.formData.hourlyRate
        }
        this.AdditionalTasksService.createTask(this.ProjectService.project.id, payload)
          .then(task => {
            // SegmentAnalytics.trackSubtaskPosted(task, Auth.me());
            // $rootScope.$broadcast('sub-task-created', task);
            this.ProjectService.addAdditionalTaskToProject(task, true)
            this.modalCtrl.close()
          })
          .finally(() => {
            this.isProcessing = false
          })
      }
    }
  }
}

export default AdditionalTasksCreateModalComponent
